import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import PageHeader from "../components/PageHeader";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: "", message: "" });
  const formRef = useRef();

  // EmailJS Configuration - Replace with your actual IDs
  const SERVICE_ID = "service_3rxeigp"; // Replace with your EmailJS Service ID
  const TEMPLATE_ID = "template_8cfivsz"; // Replace with your EmailJS Template ID
  const PUBLIC_KEY = "CE66FssCF1c4ZpJZG"; // Replace with your EmailJS Public Key

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Clear status message when user starts typing
    if (submitStatus.message) {
      setSubmitStatus({ type: "", message: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: "", message: "" });

    try {
      const response = await emailjs.sendForm(
        SERVICE_ID,
        TEMPLATE_ID,
        formRef.current,
        PUBLIC_KEY
      );

      if (response.status === 200) {
        setSubmitStatus({
          type: "success",
          message: "Thank you for your message! We will get back to you soon.",
        });

        // Reset the form
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
        formRef.current.reset();
      } else {
        throw new Error("Failed to send email");
      }
    } catch (error) {
      console.error("Email Error:", error);
      setSubmitStatus({
        type: "error",
        message:
          error.text ||
          "Sorry, there was an error sending your message. Please try again later or contact us directly.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <PageHeader
        title="CONTACT US"
        subtitle="Let's Start a Conversation"
        backgroundImage="/images/Contactbg.png"
      />
      <div className="page-content">
        <div className="container">
          <p
            style={{
              textAlign: "center",
              marginBottom: "2rem",
              maxWidth: "600px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            We look forward to exploring how we can partner to achieve your
            goals. If you're seeking innovative, effective, and reliable IT
            solutions, then MindXchange could be the trusted partner for you.
          </p>
          <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                placeholder="Tell us about your project..."
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            {submitStatus.message && (
              <div
                className={`submit-status ${submitStatus.type}`}
                style={{
                  padding: "1rem",
                  marginBottom: "1rem",
                  borderRadius: "5px",
                  textAlign: "center",
                  backgroundColor:
                    submitStatus.type === "success" ? "#d4edda" : "#f8d7da",
                  color:
                    submitStatus.type === "success" ? "#155724" : "#721c24",
                  border: `1px solid ${
                    submitStatus.type === "success" ? "#c3e6cb" : "#f5c6cb"
                  }`,
                }}
              >
                {submitStatus.message}
              </div>
            )}
            <div style={{ textAlign: "center" }}>
              <button
                type="submit"
                className="submit-btn"
                disabled={isSubmitting}
                style={{
                  opacity: isSubmitting ? 0.6 : 1,
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                }}
              >
                {isSubmitting ? "Sending..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
